/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */

import styled from 'styled-components';

import { colors, fonts } from '@/main/theme';

export const WizardAdditionalReportsStepChooseStyled = styled.div.attrs({
    className: 'wizard-additional-reports',
})`
    user-select: none;
    margin-top: 20px;
    max-width: 560px;

    .wizard-additional-reports__title {
        ${fonts.textMainBold};
        margin-bottom: 12px;
    }

    .wizard-additional-reports__group-control {
        width: fit-content;
        margin-bottom: 24px;
    }
`

export const WizardAdditionalReportsStepPrepareStyled = styled.div.attrs({
    className: 'wizard-additional-reports',
})`
    user-select: none;
    margin-top: 20px;
    max-width: 560px;

    .wizard-additional-reports__sub-group {
        margin-top: 24px;
        margin-left: 32px;
    }

    .wizard-additional-reports__group-control {
        width: fit-content;
        margin-bottom: 24px;
    }

    .wizard-additional-reports__group-row {
        display: flex;
        & > *:not(:last-child) {
            margin-right: 12px;
        }
    }

    .wizard-additional-reports__title {
        ${fonts.textMainBold};
        margin-top: 12px;
        margin-bottom: 12px;
    }

    .wizard-additional-reports__info {
        margin-bottom: 12px;
        color: ${colors.textColorOpacity}
    }

    .wizard-additional-reports__prompt {
        ${fonts.textSmall};
        color: ${colors.textColorOpacity};
    }
`

export const WizardAdditionalReportsStepConfirmationStyled = styled.div.attrs({
    className: 'wizard-additional-reports',
})`
    display: grid;
    grid-template-columns: 1fr 1fr;

    margin-top: 20px;
`;

export const WizardAdditionalReportsPeriodStyled = styled.div`
    width: 220px;
`;
